/**
 * Formatea un texto a "Title Case"
 * Ejemplo
 * Texto Original: botella de AGUA.
 * Texto Formateado: Botella De Agua.
 */
export function toTitleCase(value) {
  if (!value) return "";
  return value.toLowerCase().split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * Formatea un texto a "Sentence Case"
 * Ejemplo
 * Texto Original: botella de AGUA.
 * Texto Formateado: Botella de agua.
 * 
 * @param {any} value - Valor a convertir
 * @returns {string}
 */
export function toSentenceCase(value) {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

/**
 * Convierte cualquier valor a minúsculas de forma segura.
 * - Si el valor es null/undefined, retorna '' (string vacío).
 * - Si no es string, intenta convertirlo con String().
 * - Evita romperse al llamar toLowerCase() en valores nulos.
 *
 * @param {any} value - Valor a convertir
 * @returns {string}
 */
export function toLowerSafe(value) {
  if (typeof value === 'string') return value.trim().toLowerCase();
  if (value == null) return '';
  try {
    return String(value).trim().toLowerCase();
  } catch {
    return '';
  }
}

/**
 * Convierte cualquier valor a mayúsculas de forma segura.
 * - Si el valor es null/undefined, retorna '' (string vacío).
 * - Si no es string, intenta convertirlo con String().
 * - Evita romperse al llamar toUpperCase() en valores nulos.
 *
 * @param {any} value - Valor a convertir
 * @returns {string}
 */
export function toUpperSafe(value) {
  if (typeof value === 'string') return value.trim().toUpperCase();
  if (value == null) return '';
  try {
    return String(value).trim().toUpperCase();
  } catch {
    return '';
  }
}

  